import { DASHBOARD_WIDGET_KIND_VALUES, DASHBOARD_WIDGET_STATUS_VALUES, valueMap } from "../platform/domain-values";

export const DASHBOARD_WIDGET_KINDS = valueMap(DASHBOARD_WIDGET_KIND_VALUES);
export const DASHBOARD_WIDGET_STATUSES = valueMap(DASHBOARD_WIDGET_STATUS_VALUES);
